import {createPinia, Pinia} from "pinia";
import piniaPersistent from 'pinia-plugin-persistedstate';

declare global
{
   interface Window
   {
      pinia :Pinia
   }
}

export abstract class BaseModule
{

   public onLoad() :void { }
   public onReady() :void { }
   public onResize() :void { }

   public async prepare() :Promise<void> { }

   public getDatabaseEnabledName() :string|null {
      return null;
   }

   public static getPiniaInstance() {
      if(!window['pinia']){
         let pinia = createPinia();
         pinia.use(piniaPersistent);
         window['pinia'] = pinia;
      }

      return window['pinia'];
   }
}